import widgetDefaults from '../../data/widgetDefaults';

export default function useWidget<
  T extends keyof Edge.AllWidgetsByKey,
  R extends Edge.AllWidgetsByKey[T],
>(widgetId: T): R {
  return widgetDefaults[widgetId as keyof typeof widgetDefaults] as R;
}
